<template>
  <div>

    <el-crud
      :baseUrl="'/shifts'"
      name="shifts"
      v-model="resource"
      :actions="['edit','delete']"
      :config="crudConfig"
      ref="crud"
    >

      <template slot="table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <template v-if="scope.row.type == 'CMP'">
              Compensatorio
            </template>
            <template v-else-if="scope.row.type == 'FLEX'">
              <table class="details">
                <tr>
                  <td><strong>Lunes:</strong></td>
                  <td>{{scope.row.definition.mon_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Martes:</strong></td>
                  <td>{{scope.row.definition.tue_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Miércoles:</strong></td>
                  <td>{{scope.row.definition.wed_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Jueves:</strong></td>
                  <td>{{scope.row.definition.thu_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Viernes:</strong></td>
                  <td>{{scope.row.definition.fri_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Sábado:</strong></td>
                  <td>{{scope.row.definition.sat_hours}} hs.</td>
                </tr>
                <tr>
                  <td><strong>Domingo:</strong></td>
                  <td>{{scope.row.definition.sun_hours}} hs.</td>
                </tr>
              </table>
            </template>
            <template v-else-if="scope.row.type == 'TOFF'">
              <strong>Horas computadas:</strong> {{scope.row.definition.computed_hours}}
            </template>
            <template v-else-if="scope.row.type == 'FRAC' || scope.row.type == 'FRAC_NOC'">
              <table class="details">
                <tr v-for="(label, key) in weekDays" :key="key">
                  <td><strong>{{label}}:</strong></td>
                  <td>
                    <template v-if="scope.row.definition[key+'_check_in_time']">
                      {{scope.row.definition[key+'_check_in_time']}} - {{scope.row.definition[key+'_check_out_time']}}
                                             <span v-if="scope.row.definition[key+'_hours']">({{ scope.row.definition[key + '_hours'] }} hs.)</span>
                    </template>
                    <template v-else>-</template>
                  </td>
                </tr>
                <tr>
                  <td><strong>Posición cálculo H.E.:</strong></td>
                  <td>{{ (scope.row.definition && scope.row.definition.extra_calc_position == 'end') ? 'Fin' : 'Inicio' }}</td>
                </tr>
                <tr v-if="scope.row.definition && scope.row.definition.duplicate_punch_tolerance !== undefined && scope.row.definition.duplicate_punch_tolerance !== null && scope.row.definition.duplicate_punch_tolerance !== ''">
                  <td><strong>Marcación continua:</strong></td>
                  <td>{{ scope.row.definition.duplicate_punch_tolerance }} minutos</td>
                </tr>
              </table>
            </template>
            <template v-else>
              <table class="details">
                <tr>
                  <td><strong>Lunes:</strong></td>
                  <td>{{scope.row.definition.mon_check_in_time}} - {{scope.row.definition.mon_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Martes:</strong></td>
                  <td>{{scope.row.definition.tue_check_in_time}} - {{scope.row.definition.tue_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Miércoles:</strong></td>
                  <td>{{scope.row.definition.wed_check_in_time}} - {{scope.row.definition.wed_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Jueves:</strong></td>
                  <td>{{scope.row.definition.thu_check_in_time}} - {{scope.row.definition.thu_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Viernes:</strong></td>
                  <td>{{scope.row.definition.fri_check_in_time}} - {{scope.row.definition.fri_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Sábado:</strong></td>
                  <td>{{scope.row.definition.sat_check_in_time}} - {{scope.row.definition.sat_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Domingo:</strong></td>
                  <td>{{scope.row.definition.sun_check_in_time}} - {{scope.row.definition.sun_check_out_time}}</td>
                </tr>
                <tr>
                  <td><strong>Posición cálculo H.E.:</strong></td>
                  <td>{{ (scope.row.definition && scope.row.definition.extra_calc_position == 'end') ? 'Fin' : 'Inicio' }}</td>
                </tr>
              </table>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Código">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :color="(scope.row.definition.color) ? scope.row.definition.color : '#FFFFFF'"
              :style="';color:' + invertColor((scope.row.definition.color != null) ? scope.row.definition.color : '#FFFFFF', true)"
            >{{scope.row.company_id_number}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="Descripción"
        >
        </el-table-column>
        <el-table-column
          width="80"
          align="right"
          header-align="center"
          label="Descanso Diurno"
        >
          <template slot-scope="scope">
            {{(scope.row.definition.break_time != undefined) ? scope.row.definition.break_time : 0}} min.
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          align="right"
          header-align="center"
          label="Descanso Nocturno"
        >
          <template slot-scope="scope">
            {{(scope.row.definition.night_break_time != undefined) ? scope.row.definition.night_break_time : 0}} min.
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          align="right"
          header-align="center"
          label="Tolerancia Entrada"
        >
          <template slot-scope="scope">
            Temprano: {{scope.row.definition.tolerance_early_check_in}} min.<br>Tarde: {{scope.row.definition.tolerance_late_check_in}} min.
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          align="right"
          header-align="center"
          label="Tolerancia Salida"
        >
          <template slot-scope="scope">
            Temprano: {{scope.row.definition.tolerance_early_check_out}} min.<br>Tarde: {{scope.row.definition.tolerance_late_check_out}} min.
          </template>
        </el-table-column>
        <el-table-column
          align="right"
          header-align="center"
          prop="feeding"
          label="Alimentación"
        >
        </el-table-column>
      </template>

      <template
        slot="form"
        slot-scope="scope"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Tipo"
              label-width="140px"
              :prop="resource.type"
              :error="scope.errors.type"
            >
              <el-select
                v-model="resource.type"
                size="mini"
              >
                <el-option
                  key="DEFAULT"
                  label="Normal"
                  :value="null"
                ></el-option>
                <el-option
                  key="PRENOC"
                  label="Nocturno empezando el día anterior"
                  value="PRENOC"
                ></el-option>
                <el-option
                  key="FLEX"
                  label="Flexible"
                  value="FLEX"
                ></el-option>
                <el-option
                  key="FRAC"
                  label="Turno Fraccionado"
                  value="FRAC"
                ></el-option>
                <el-option
                  key="FRAC_NOC"
                  label="Turno Fraccionado Nocturno"
                  value="FRAC_NOC"
                ></el-option>
                <el-option
                  key="CMP"
                  label="Compensatorio"
                  value="CMP"
                ></el-option>
                <el-option
                  key="CHOS"
                  label="Considera festivos por sobre el turno (para administrativos)"
                  value="CHOS"
                ></el-option>
                <el-option
                  key="TOFF"
                  label="No Laborado"
                  value="TOFF"
                ></el-option>
              </el-select>
              <el-alert
                v-if="shiftTypeDescription"
                :title="shiftTypeDescription"
                type="info"
                :closable="false"
                show-icon
                style="margin-top: 10px;"
              >
              </el-alert>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Código"
              label-width="140px"
              :prop="resource.company_id_number"
              :error="scope.errors.company_id_number"
            >
              <el-input
                v-model="resource.company_id_number"
                auto-complete="off"
                size="small"
              >
                <el-color-picker
                  slot="suffix"
                  v-model="resource.definition.value.color"
                  size="mini"
                  style="margin-top: 2px;"
                ></el-color-picker>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Descripción"
              label-width="140px"
              :prop="resource.description"
              :error="scope.errors.description"
            >
              <el-input
                v-model="resource.description"
                auto-complete="off"
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="showBreakTimes"
          >
            <el-form-item
              label="Alimentación"
              label-width="140px"
              :prop="resource.feeding"
              :error="scope.errors.feeding"
            >
              <el-input
                v-model="resource.feeding"
                auto-complete="off"
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="resource.type == 'CMP'"></template>
        <template v-else-if="resource.type == 'FLEX'">
          <h4>Horas</h4>
          <el-form-item
            v-for="(label, key) in weekDays"
            :key="key"
            :label="label"
            label-width="140px"
            :error="scope.errors.definition"
          >
            <el-input
              size="mini"
              v-model="resource.definition.value[key+'_hours']"
              placeholder="Horas"
            >
              <template slot="append">horas</template>
            </el-input>
          </el-form-item>
        </template>
        <template v-else-if="resource.type == 'TOFF'">
          <el-form-item
            label="Horas computadas"
            label-width="140px"
            :error="scope.errors.definition"
          >
            <el-col :span="11">
              <el-select
                v-model="resource.definition.value.time_off_compute_type"
                style="width: 200px;"
              >
                <el-option
                  label="No computar"
                  value="no"
                ></el-option>
                <el-option
                  label="Cantidad de horas fija"
                  value="fixed"
                ></el-option>
                <el-option
                  label="Horas diarias del acuerdo laboral"
                  value="hours_per_day"
                ></el-option>
              </el-select>
            </el-col>
            <el-col
              class="line"
              :span="2"
              style="text-align: center;"
            ></el-col>
            <el-col :span="11">
              <el-input
                v-if="resource.definition.value.time_off_compute_type == 'fixed'"
                v-model="resource.definition.value.time_off_hours"
                class="input-with-select"
                size="mini"
              >
                <template slot="append">horas</template>
              </el-input>
            </el-col>
          </el-form-item>
        </template>
        <template v-else-if="resource.type == 'FRAC' || resource.type == 'FRAC_NOC'">
          <h4>Horarios y Horas por Turno</h4>
          <el-form-item
            v-for="(label, key) in weekDays"
            :key="key"
            :label="label"
            label-width="140px"
            :error="scope.errors.definition"
          >
            <el-col :span="7">
              <el-time-picker
                size="mini"
                v-model="resource.definition.value[key+'_check_in_time']"
                :picker-options="{format:'HH:mm'}"
                style="width: 100%;"
                placeholder="Entrada"
              >
              </el-time-picker>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="text-align: center;"
            >-</el-col>
            <el-col :span="7">
              <el-time-picker
                size="mini"
                v-model="resource.definition.value[key+'_check_out_time']"
                :picker-options="{format:'HH:mm'}"
                style="width: 100%;"
                placeholder="Salida"
              >
              </el-time-picker>
            </el-col>
            <el-col
              class="line"
              :span="1"
              style="text-align: center;"
            >&nbsp;</el-col>
            <el-col :span="8">
              <el-input
                size="mini"
                v-model="resource.definition.value[key+'_hours']"
                placeholder="Horas por turno"
              >
                <template slot="append">hs.</template>
              </el-input>
            </el-col>
          </el-form-item>
          <!-- Selector posición cálculo horas extra -->
          <el-form-item label="Posición de cálculo de horas extra" :error="scope.errors.definition">
            <el-tooltip class="item" effect="dark" content="Define si la hora extra se calcula al inicio o al final del turno. Por defecto es 'start'." placement="top">
              <el-select v-model="resource.definition.value.extra_calc_position" placeholder="Seleccionar" size="mini" style="width: 100%;">
                <el-option label="Inicio" value="start"></el-option>
                <el-option label="Fin" value="end"></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-col
            span="22"
            offset="4"
          >
            <el-checkbox v-model="resource.definition.value.compensated">Domingos y festivos compensados</el-checkbox>
          </el-col>
        </template>
        <template v-else>
          <h4>Horarios</h4>
          <el-form-item
            v-for="(label, key) in weekDays"
            :key="key"
            :label="label"
            label-width="140px"
            :error="scope.errors.definition"
          >
            <el-col span="11">
              <el-time-picker
                size="mini"
                v-model="resource.definition.value[key+'_check_in_time']"
                :picker-options="{format:'HH:mm'}"
                style="width: 100%;"
                placeholder="Entrada"
              >
              </el-time-picker>
            </el-col>
            <el-col
              class="line"
              span="2"
              style="text-align: center;"
            >-</el-col>
            <el-col span="11">
              <el-time-picker
                size="mini"
                v-model="resource.definition.value[key+'_check_out_time']"
                :picker-options="{format:'HH:mm'}"
                style="width: 100%;"
                placeholder="Salida"
              >
              </el-time-picker>
            </el-col>
          </el-form-item>
          <!-- Selector posición cálculo horas extra -->
          <el-form-item label="Posición de cálculo de horas extra" label-width="140px" :error="scope.errors.definition">
            <el-tooltip class="item" effect="dark" content="Define si la hora extra se calcula al inicio o al final del turno. Por defecto es 'start'." placement="top">
              <el-select v-model="resource.definition.value.extra_calc_position" placeholder="Seleccionar" size="mini" style="width: 100%;">
                <el-option label="Inicio" value="start"></el-option>
                <el-option label="Fin" value="end"></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-col
            span="22"
            offset="4"
          >
            <el-checkbox v-model="resource.definition.value.compensated">Domingos y festivos compensados</el-checkbox>
          </el-col>
        </template>

        <template v-if="showBreakTimes">
          <h4>Descansos</h4>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="Diurno"
                label-width="140px"
                :prop="resource.definition.value.break_time"
              >
                <el-input
                  v-model="resource.definition.value.break_time"
                  auto-complete="off"
                  size="mini"
                >
                  <template slot="append">minutos</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Nocturno"
                label-width="140px"
                :prop="resource.definition.value.night_break_time"
              >
                <el-input
                  v-model="resource.definition.value.night_break_time"
                  auto-complete="off"
                  size="mini"
                >
                  <template slot="append">minutos</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <template v-if="showTolerances">

          <div>
            <h4 style="display:inline-block; margin-right:42px;">Modo</h4>
            <el-radio-group
              v-model="flex"
              size="mini"
            >
              <el-radio-button :label="true">Flexible</el-radio-button>
              <el-radio-button :label="false">Tolerancias</el-radio-button>
            </el-radio-group>
          </div>

          <template v-if="flex">
            <h4>Flexibilidad</h4>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="Entrada antes"
                  label-width="140px"
                  :prop="resource.definition.value.flex_early_check_in"
                >
                  <el-input
                    v-model="resource.definition.value.flex_early_check_in"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Entrada después"
                  label-width="140px"
                  :prop="resource.definition.value.flex_late_check_in"
                >
                  <el-input
                    v-model="resource.definition.value.flex_late_check_in"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <template v-else>
            <h4>Tolerancias</h4>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="Entrada temprano"
                  label-width="140px"
                  :prop="resource.definition.value.tolerance_early_check_in"
                >
                  <el-input
                    v-model="resource.definition.value.tolerance_early_check_in"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Entrada tarde"
                  label-width="140px"
                  :prop="resource.definition.value.tolerance_late_check_in"
                >
                  <el-input
                    v-model="resource.definition.value.tolerance_late_check_in"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="Salida temprano"
                  label-width="140px"
                  :prop="resource.definition.value.tolerance_early_check_out"
                >
                  <el-input
                    v-model="resource.definition.value.tolerance_early_check_out"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Salida tarde"
                  label-width="140px"
                  :prop="resource.definition.value.tolerance_late_check_out"
                >
                  <el-input
                    v-model="resource.definition.value.tolerance_late_check_out"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="resource.type == 'FRAC' || resource.type == 'FRAC_NOC'">
              <el-col :span="12">
                <el-form-item
                  label="Marcación continua"
                  label-width="140px"
                  :prop="resource.definition.value.duplicate_punch_tolerance"
                >
                  <el-input
                    v-model="resource.definition.value.duplicate_punch_tolerance"
                    placeholder="Minutos"
                    auto-complete="off"
                    size="mini"
                  >
                    <template slot="append">minutos</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

        </template>
      </template>
    </el-crud>

  </div>
</template>

<style>
/* .el-date-editor.el-input{
    width: 120px;
}
.el-input{
    width: 120px;
} */
</style>
<script>
import el_crud from '../el-crud.vue';
import { invertColor } from '../../utils/lib';
export default {
  data() {
    return {
      crudConfig: {
        AddItemTitle: 'Nuevo Turno',
        EditItemTitle: 'Editar Turno',
        DeleteItemConfirmMessage: 'Esto borrará permanentemente el turno. Desea continuar?'
      },
      flex: false,
      resource: {
        description: null,
        type: null,
        company_id_number: null,
        feeding: null,
        definition: {
          value: {
            mon_check_in_time: null,
            mon_check_out_time: null,
            tue_check_in_time: null,
            tue_check_out_time: null,
            wed_check_in_time: null,
            wed_check_out_time: null,
            thu_check_in_time: null,
            thu_check_out_time: null,
            fri_check_in_time: null,
            fri_check_out_time: null,
            sat_check_in_time: null,
            sat_check_out_time: null,
            sun_check_in_time: null,
            sun_check_out_time: null,
            mon_hours: null,
            tue_hours: null,
            wed_hours: null,
            thu_hours: null,
            fri_hours: null,
            sat_hours: null,
            sun_hours: null,
            break_time: null,
            night_break_time: null,
            tolerance_early_check_in: null,
            tolerance_late_check_in: null,
            tolerance_early_check_out: null,
            tolerance_late_check_out: null,
            color: null,
            time_off_compute_type: null,
            time_off_hours: null,
            flex_early_check_in: null,
            flex_late_check_in: null,
            compensated: false,
            duplicate_punch_tolerance: null,
            extra_calc_position: 'start',
          },
          setValue: (value) => {
            _.each(this.weekDays, (label, key) => {
              if (value != null && key + '_check_in_time' in value.definition && value.definition[key + '_check_in_time'] != null) {
                let time = value.definition[key + '_check_in_time'].split(':');
                this.resource.definition.value[key + '_check_in_time'] = new Date(2000, 0, 1, parseInt(time[0]), parseInt(time[1]), 0);
              } else {
                this.resource.definition.value[key + '_check_in_time'] = null;
              }
              if (value != null && key + '_check_out_time' in value.definition && value.definition[key + '_check_out_time'] != null) {
                let time = value.definition[key + '_check_out_time'].split(':');
                this.resource.definition.value[key + '_check_out_time'] = new Date(2000, 0, 1, parseInt(time[0]), parseInt(time[1]), 0);
              } else {
                this.resource.definition.value[key + '_check_out_time'] = null;
              }
            });
            if (value != null && 'mon_hours' in value.definition) {
              this.resource.definition.value.mon_hours = value.definition.mon_hours;
            } else {
              this.resource.definition.value.mon_hours = null;
            }
            if (value != null && 'tue_hours' in value.definition) {
              this.resource.definition.value.tue_hours = value.definition.tue_hours;
            } else {
              this.resource.definition.value.tue_hours = null;
            }
            if (value != null && 'wed_hours' in value.definition) {
              this.resource.definition.value.wed_hours = value.definition.wed_hours;
            } else {
              this.resource.definition.value.wed_hours = null;
            }
            if (value != null && 'thu_hours' in value.definition) {
              this.resource.definition.value.thu_hours = value.definition.thu_hours;
            } else {
              this.resource.definition.value.thu_hours = null;
            }
            if (value != null && 'fri_hours' in value.definition) {
              this.resource.definition.value.fri_hours = value.definition.fri_hours;
            } else {
              this.resource.definition.value.fri_hours = null;
            }
            if (value != null && 'sat_hours' in value.definition) {
              this.resource.definition.value.sat_hours = value.definition.sat_hours;
            } else {
              this.resource.definition.value.sat_hours = null;
            }
            if (value != null && 'sun_hours' in value.definition) {
              this.resource.definition.value.sun_hours = value.definition.sun_hours;
            } else {
              this.resource.definition.value.sun_hours = null;
            }
            if (value != null && 'break_time' in value.definition) {
              this.resource.definition.value.break_time = value.definition.break_time;
            } else {
              this.resource.definition.value.break_time = null;
            }
            if (value != null && 'night_break_time' in value.definition) {
              this.resource.definition.value.night_break_time = value.definition.night_break_time;
            } else {
              this.resource.definition.value.night_break_time = null;
            }
            if (value != null && 'tolerance_early_check_in' in value.definition) {
              this.resource.definition.value.tolerance_early_check_in = value.definition.tolerance_early_check_in;
            } else {
              this.resource.definition.value.tolerance_early_check_in = null;
            }
            if (value != null && 'tolerance_late_check_in' in value.definition) {
              this.resource.definition.value.tolerance_late_check_in = value.definition.tolerance_late_check_in;
            } else {
              this.resource.definition.value.tolerance_late_check_in = null;
            }
            if (value != null && 'tolerance_early_check_out' in value.definition) {
              this.resource.definition.value.tolerance_early_check_out = value.definition.tolerance_early_check_out;
            } else {
              this.resource.definition.value.tolerance_early_check_out = null;
            }
            if (value != null && 'tolerance_late_check_out' in value.definition) {
              this.resource.definition.value.tolerance_late_check_out = value.definition.tolerance_late_check_out;
            } else {
              this.resource.definition.value.tolerance_late_check_out = null;
            }
            if (value != null && 'color' in value.definition) {
              this.resource.definition.value.color = value.definition.color;
            } else {
              this.resource.definition.value.color = null;
            }
            if (value != null && 'time_off_compute_type' in value.definition) {
              this.resource.definition.value.time_off_compute_type = value.definition.time_off_compute_type;
            } else {
              this.resource.definition.value.time_off_compute_type = null;
            }
            if (value != null && 'time_off_hours' in value.definition) {
              this.resource.definition.value.time_off_hours = value.definition.time_off_hours;
            } else {
              this.resource.definition.value.time_off_hours = null;
            }
            this.flex = false;
            if (value != null && 'flex_early_check_in' in value.definition) {
              this.resource.definition.value.flex_early_check_in = value.definition.flex_early_check_in;
              if (value.definition.flex_early_check_in != null) {
                this.flex = true;
              }
            } else {
              this.resource.definition.value.flex_early_check_in = null;
            }
            if (value != null && 'flex_late_check_in' in value.definition) {
              this.resource.definition.value.flex_late_check_in = value.definition.flex_late_check_in;
              if (value.definition.flex_late_check_in != null) {
                this.flex = true;
              }
            } else {
              this.resource.definition.value.flex_late_check_in = null;
            }
            if (value != null && 'compensated' in value.definition) {
              this.resource.definition.value.compensated = value.definition.compensated;
            } else {
              this.resource.definition.value.compensated = false;
            }
            if (value != null && 'duplicate_punch_tolerance' in value.definition) {
              this.resource.definition.value.duplicate_punch_tolerance = value.definition.duplicate_punch_tolerance;
            } else {
              this.resource.definition.value.duplicate_punch_tolerance = null;
            }
            if (value != null && 'extra_calc_position' in value.definition) {
              this.resource.definition.value.extra_calc_position = value.definition.extra_calc_position;
            } else {
              this.resource.definition.value.extra_calc_position = 'start';
            }
          },
          getValue: () => {
            let definition = {};
            _.each(this.weekDays, (label, key) => {
              if (this.resource.definition.value[key + '_check_in_time'] != undefined && this.resource.definition.value[key + '_check_in_time'] != null) {
                definition[key + '_check_in_time'] = moment(this.resource.definition.value[key + '_check_in_time']).format('HH:mm');
              } else {
                definition[key + '_check_in_time'] = null;
              }
              if (this.resource.definition.value[key + '_check_out_time'] != undefined && this.resource.definition.value[key + '_check_out_time'] != null) {
                definition[key + '_check_out_time'] = moment(this.resource.definition.value[key + '_check_out_time']).format('HH:mm');
              } else {
                definition[key + '_check_out_time'] = null;
              }
            });
            _.each(this.weekDays, (label, key) => {
              if (this.resource.definition.value[key + '_hours'] != undefined && this.resource.definition.value[key + '_hours'] != null) {
                definition[key + '_hours'] = this.resource.definition.value[key + '_hours'];
              } else {
                definition[key + '_hours'] = null;
              }
            });
            definition.break_time = this.resource.definition.value.break_time;
            definition.night_break_time = this.resource.definition.value.night_break_time;
            if (this.flex) {
              definition.tolerance_early_check_in = null;
              definition.tolerance_late_check_in = null;
              definition.tolerance_early_check_out = null;
              definition.tolerance_late_check_out = null;
              definition.flex_early_check_in = this.resource.definition.value.flex_early_check_in;
              definition.flex_late_check_in = this.resource.definition.value.flex_late_check_in;
            } else {
              definition.tolerance_early_check_in = this.resource.definition.value.tolerance_early_check_in;
              definition.tolerance_late_check_in = this.resource.definition.value.tolerance_late_check_in;
              definition.tolerance_early_check_out = this.resource.definition.value.tolerance_early_check_out;
              definition.tolerance_late_check_out = this.resource.definition.value.tolerance_late_check_out;
              definition.flex_early_check_in = null;
              definition.flex_late_check_in = null;
            }
            definition.color = this.resource.definition.value.color;
            definition.time_off_compute_type = this.resource.definition.value.time_off_compute_type;
            definition.time_off_hours = this.resource.definition.value.time_off_hours;

            definition.compensated = this.resource.definition.value.compensated;
            definition.duplicate_punch_tolerance = this.resource.definition.value.duplicate_punch_tolerance;
            definition.extra_calc_position = this.resource.definition.value.extra_calc_position || 'start';
            return definition;
          }
        }
      },
      weekDays: {
        mon: 'Lunes',
        tue: 'Martes',
        wed: 'Miércoles',
        thu: 'Jueves',
        fri: 'Viernes',
        sat: 'Sábado',
        sun: 'Domingo',
      },
    };
  },
  components: {
    'el-crud': el_crud,
  },
  computed: {
    'showTolerances': function () {
      return this.resource.type == null || this.resource.type == 'DEFAULT' || this.resource.type == 'PRENOC' || this.resource.type == 'CHOS' || this.resource.type == 'FRAC' || this.resource.type == 'FRAC_NOC';
    },
    'showBreakTimes': function () {
      return this.resource.type == null || this.resource.type == 'DEFAULT' || this.resource.type == 'PRENOC' || this.resource.type == 'FLEX' || this.resource.type == 'CHOS' || this.resource.type == 'FRAC' || this.resource.type == 'FRAC_NOC';
    },
    'flex': function () {
      return this.resource.definition.value.flex_early_check_in != null || this.resource.definition.value.flex_late_check_in != null;
    },
    'shiftTypeDescription': function () {
      const descriptions = {
        'DEFAULT': 'Turno estándar con horarios fijos de entrada y salida para cada día de la semana.',
        'PRENOC': 'Turno para jornadas nocturnas que inician en el día calendario previo y finalizan al día siguiente.',
        'FLEX': 'Permite un horario de entrada flexible dentro de una ventana de tiempo, recalculando la salida automáticamente.',
        'FRAC': 'Turno con múltiples entradas y salidas en el día. Permite configurar rango de horario (Inicio/Fin), horas tope por turno y tolerancia entre marcaciones continuas.',
        'FRAC_NOC': 'Turno fraccionado nocturno que inicia en la noche del día asignado y finaliza la mañana del día siguiente (+1 día). Permite múltiples marcaciones nocturnas y definición de horas por turno manuales.',
        'CMP': 'Turno utilizado para días de descanso compensatorio.',
        'CHOS': 'Turno administrativo que evalúa días festivos sobre el horario asignado.',
        'TOFF': 'Identifica días no laborados o ausencias justificadas con cálculo de horas fijas o del acuerdo laboral.'
      };
      const key = this.resource.type || 'DEFAULT';
      return descriptions[key] || '';
    }
  },
  methods: {
    invertColor,
  }
}
</script>
